import { ReportData } from '../types/reportTypes';

// Parse currency string to number
const parseCurrency = (value: string): number => {
  if (!value || value === '') return 0;
  return parseFloat(value.replace(/[$,]/g, ''));
};

// Parse percentage string to number
const parsePercentage = (value: string): number => {
  if (!value || value === '') return 0;
  return parseFloat(value.replace(/%/g, '')) / 100;
};

// Calculate the sum of an array of numbers
const sum = (numbers: number[]): number => {
  return numbers.reduce((total, num) => total + num, 0);
};

// Calculate net profit and commission for Cody Cline reports
const calculateCodyNetProfit = (grossProfit: number, companyOH: number): number => {
  // For Cody Cline: Net Profit = Gross Profit - Company OH
  return grossProfit - companyOH;
};

const calculateCodyCommission = (netProfit: number): number => {
  // For Cody Cline: Sales Commission = 50% of Net Profit
  return netProfit / 2;
};

// Calculate the individual job data from the Cody Sales April CSV
const jobData = [// IMPORTANT: Using 13% flat OH calculation (Contract Total × 0.13) retroactive to 1/1/2025
  {
    jobInfo: "E-307: Carolyn Tracy",
    leadSource: "Google Organic Search",
    trade: "Siding",
    contractTotal: 6375.00,
    grossMarginPct: 0.5188,
    grossProfit: 3307.35,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6375.00 * 0.13, // 13% flat rate
    netProfit: 5386.87
  },
  {
    jobInfo: "E-312: Rubin & Monica Neypes",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 6994.81,
    grossMarginPct: 0.4028,
    grossProfit: 2817.51,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6994.81 * 0.13, // 13% flat rate
    netProfit: 5910.61
  },
  {
    jobInfo: "E-332: Megan Sprayberry",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 62675.45,
    grossMarginPct: 0.3165,
    grossProfit: 19836.78,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 62675.45 * 0.13, // 13% flat rate
    netProfit: 52960.76
  },
  {
    jobInfo: "E-303: Carl & Bonnie Sink",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 1172.00,
    grossMarginPct: 0.4881,
    grossProfit: 572.05,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1172.00 * 0.13, // 13% flat rate
    netProfit: 990.34
  },
  {
    jobInfo: "E-281: Chris Meckel",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 799.00,
    grossMarginPct: 0.6746,
    grossProfit: 539.01,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 799.00 * 0.13, // 13% flat rate
    netProfit: 675.15
  },
  {
    jobInfo: "E-311: Ballard Green Condo 1",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 31145.00,
    grossMarginPct: 0.6154,
    grossProfit: 19166.63,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 31145.00 * 0.13, // 13% flat rate
    netProfit: 26317.52
  },
  {
    jobInfo: "E-329: Ryan Smet",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 1499.00,
    grossMarginPct: 0.4129,
    grossProfit: 618.94,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1499.00 * 0.13, // 13% flat rate
    netProfit: 1266.65
  },
  {
    jobInfo: "E-285: Jason Downie",
    leadSource: "Referral- Dominic's network",
    trade: "Windows & Doors",
    contractTotal: 1999.00,
    grossMarginPct: 0.3060,
    grossProfit: 611.69,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1999.00 * 0.13, // 13% flat rate
    netProfit: 1689.15
  },
  {
    jobInfo: "E-278: Joe Ann stenstrom",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 1385.00,
    grossMarginPct: 0.6334,
    grossProfit: 877.26,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1385.00 * 0.13, // 13% flat rate
    netProfit: 1170.32
  },
  {
    jobInfo: "E-290: Ellicott Hills Condo 2",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 4997.00,
    grossMarginPct: 0.4000,
    grossProfit: 1998.80,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 4997.00 * 0.13, // 13% flat rate
    netProfit: 4222.46
  },
  {
    jobInfo: "E-301: The Enclave At Ellicott Hills",
    leadSource: "Referral- Dominic's network",
    trade: "Uncategorized",
    contractTotal: 4958.64,
    grossMarginPct: 0.4000,
    grossProfit: 1983.46,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 4958.64 * 0.13, // 13% flat rate
    netProfit: 4190.05
  },
  {
    jobInfo: "E-286: Jeffrey & Grace (Oran) Holliday",
    leadSource: "Email Campaign",
    trade: "Inspection & Others",
    contractTotal: 920.00,
    grossMarginPct: 0.4511,
    grossProfit: 415.01,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 920.00 * 0.13, // 13% flat rate
    netProfit: 777.40
  },
  {
    jobInfo: "E-288: Tyler & Amanda Clinch",
    leadSource: "Previous Customer",
    trade: "Siding",
    contractTotal: 26971.00,
    grossMarginPct: 0.5533,
    grossProfit: 14923.05,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 26971.00 * 0.13, // 13% flat rate
    netProfit: 22790.49
  },
  {
    jobInfo: "50: Charles Janus",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 6099.00,
    grossMarginPct: 0.1729,
    grossProfit: 1054.52,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6099.00 * 0.13, // 13% flat rate
    netProfit: 5153.65
  },
  {
    jobInfo: "E-325: Betsy and Albion Taylor",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 19912.00,
    grossMarginPct: 0.3418,
    grossProfit: 6805.92,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 19912.00 * 0.13, // 13% flat rate
    netProfit: 16825.64
  },
  {
    jobInfo: "E-315: Aion Management Metro Pointe",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 228295.00,
    grossMarginPct: 0.5304,
    grossProfit: 121087.67,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 228295.00 * 0.13, // 13% flat rate
    netProfit: 192909.27
  },
  {
    jobInfo: "E-308: Sara Vermillion",
    leadSource: "Email Campaign",
    trade: "Gutters",
    contractTotal: 27853.61,
    grossMarginPct: 0.4561,
    grossProfit: 12704.03,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 27853.61 * 0.13, // 13% flat rate
    netProfit: 23536.30
  },
  {
    jobInfo: "E-284: Melissa Sunstrom",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 15922.00,
    grossMarginPct: 0.4455,
    grossProfit: 7093.25,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 15922.00 * 0.13, // 13% flat rate
    netProfit: 13454.09
  },
  {
    jobInfo: "E-292: Danielle Grenier",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 53560.81,
    grossMarginPct: 0.4186,
    grossProfit: 22420.56,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 53560.81 * 0.13, // 13% flat rate
    netProfit: 45258.88
  },
  {
    jobInfo: "S-2751: Megan Sprayberry",
    leadSource: "Site Survey Website",
    trade: "Solar Install",
    contractTotal: 23660.00,
    grossMarginPct: 0,
    grossProfit: 0.00,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 23660.00 * 0.13, // 13% flat rate
    netProfit: 19992.70
  }
];

// Recalculate every job's net profit and commission based on Cody's rules
jobData.forEach(job => {
  // Calculate Cody's net profit (gross profit - company OH)
  job.netProfit = calculateCodyNetProfit(job.grossProfit, job.companyOH);
  
  // Calculate Cody's commission (50% of net profit)
  job.salesCommission = calculateCodyCommission(job.netProfit);
});

// Calculate totals
const totalContractValue = sum(jobData.map(job => job.contractTotal));
const totalGrossProfit = sum(jobData.map(job => job.grossProfit));
const totalCompanyOH = sum(jobData.map(job => job.companyOH));
const totalNetProfit = sum(jobData.map(job => job.netProfit));

// For Cody, commission is 50% of net profit
const totalSalesCommissions = totalNetProfit / 2;
const totalManagerFees = 0; // No manager fees for Cody

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

// April 2025 data for Cody's direct sales report - NO ad spend as noted
export const codySalesData: ReportData = {
  kpis: {
    // No ad spend for this report - direct sales
    adSpend: 0,
    
    // Sum of all contract totals
    totalSales: totalContractValue,
    
    // Sum of all gross profits
    grossProfit: totalGrossProfit,
    
    // Sum of all sales commissions (50% of net profit for Cody)
    salesCommissions: totalSalesCommissions,
    
    // Sum of all manager fees (none for Cody)
    managerFees: totalManagerFees,
    
    // Company overhead 
    companyOH: totalCompanyOH,
    
    // Net profit is now calculated as Gross Profit - Company OH
    netProfit: totalNetProfit,
    
    // Net profit as percentage of total sales
    netProfitPercent: totalNetProfit / totalContractValue,
    
    // Gross profit as percentage of total sales
    grossProfitPercent: totalGrossProfit / totalContractValue
  },
  
  // Empty ad spend by source - direct sales channel
  adSpendBySource: [
    { source: "Referral- Cody's network", spend: 0 },
    { source: "Referral- Dominic's network", spend: 0 },
    { source: "Google Organic Search", spend: 0 },
    { source: "Email Campaign", spend: 0 },
    { source: "Previous Customer", spend: 0 },
    { source: "Site Survey Website", spend: 0 }
  ],
  
  // Sales by lead source - aggregated from the CSV
  salesBySource: salesBySource,
  
  // Sales by trade - aggregated from the CSV
  salesByTrade: salesByTrade,
  
  // Individual job data from the CSV
  jobData: jobData,
  period: {
    month: 4, // April
    year: 2025
  }
};